import { helper } from '@ember/component/helper';

export function arrayCompact([items]: [[any[]]]) {
  return items.filter(Boolean);
}

export default helper(arrayCompact);
